import React, { useEffect, useState } from "react";
import { logo } from "../../Image/Index";
import { Link, useNavigate } from "react-router-dom";
import {
  Internal_Token,
  signupConfirmation,
  Token_Generator,
} from "../../services/auth";
import AuthenticationSliderLeft from "./common/AuthenticationSliderLeft";
import { decrypt, encrypt } from "../../utils/encodingdecoding";

const VerifyYourEmail = () => {
  const navigate = useNavigate();
  const [verifyEmail, setVerifyEmail] = useState(false);
  const [errorMessages, setErrorMessages] = useState(false);
  const [loader, setLoader] = useState(false);
  const [response, setResponse] = useState({});
  const [message, setMessage] = useState(false);

  useEffect(() => {
    fetch(
      window.location.href.split("code=")[1] ||
        "3ff19ad8-2308-41f2-b8cd-b6265f7b8224YXLYRVWRGP",
    );
  }, [window.location.href.split("code=")[1]]);

  const fetch = async (id) => {
    setLoader(true);
    const token = await Token_Generator();
    await signupConfirmation(token?.access_token, id).then((res) => {
      if (res?.message === "Valid Login Details") {
        setResponse({});
        setVerifyEmail(true);
        setErrorMessages(false);
        setLoader(false);
        sessionStorage.setItem("token", JSON.stringify(true));
        localStorage.setItem("token_rare", JSON.stringify(true));
        let body = {
          clientid: res?.clientid,
          grant_type: "client_credentials",
          clientsecret: res?.clientsecret,
        };
        const response = Internal_Token(body);
        response.then((respo) => {
          // res fields arrive already decrypted (services/auth.js -> decryptResponse
          // decrypts the whole response in one shot), so every field is re-encrypted
          // here to match the "encrypted at rest" shape the rest of the app expects
          // when it reads these keys back with decrypt().
          localStorage.setItem("token_gen", JSON.stringify(respo));
          localStorage.setItem("Id", encrypt(res?.merchantcode));
          localStorage.setItem("userType", encrypt(res?.userType));
          localStorage.setItem("clientid", encrypt(res?.clientid));
          localStorage.setItem("schemaId", encrypt(res?.schemaId));
          localStorage.setItem("merchantcode", encrypt(res?.merchantcode));
          localStorage.setItem("clientsecret", encrypt(res?.clientsecret));
          localStorage.setItem("schemaName", encrypt(res?.schemaName));
          localStorage.setItem("email", encrypt(res?.email));
          if (
            res?.email === "deepak@clavax.com" ||
            res?.email === "deepikab@clavax.com" ||
            res?.email === "tarunm@clavax.com"
          ) {
            localStorage.setItem("saasemail", encrypt(res?.email));
            localStorage.setItem("superAdmin", true);
          }

          localStorage.setItem("name", encrypt(res?.name));
          localStorage.setItem(
            "moduleAccess",
            encrypt(JSON.stringify(res?.moduleAccess)),
          );
          sessionStorage.removeItem("incorrectPasswordAttempts");

          navigate("/dashboard");
          setMessage(false);
          setLoader(false);
        });
      } else {
        localStorage.setItem("token", JSON.stringify(false));
        setMessage(true);
        setLoader(false);
        setResponse(response);
        setErrorMessages(true);
      }
    });
  };

  return (
    <section className="section signUpPage">
      {loader && (
        <div className="mainPreloaderMain">
          <div className="mainPreloader">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </div>
      )}
      <div className="signUpPage__main">
        <AuthenticationSliderLeft />
        <div className="signUpPage__right">
          {verifyEmail && (
            <div className="signUpPage__heading">
              <figure>
                <img src={logo} alt="logo" />
              </figure>
              <h1>Congratulations</h1>
              <h4>
                Your Email Id is Verified. Please{" "}
                <Link to="/signin">Click Here</Link> to Login
              </h4>
            </div>
          )}
          {errorMessages && !verifyEmail && (
            <div className="signUpPage__heading">
              <figure>
                <img src={logo} alt="logo" />
              </figure>
              <h4>This link is expired</h4>
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default VerifyYourEmail;
